// Zentrale, seitenspezifische SEO-Konfiguration für die öffentlichen Voyalyo-Routen.
// Canonical-Host ausschließlich https://voyalyo.de. Nur reale Router-Routen.
export const SEO_ORIGIN = "https://voyalyo.de";
export const OG_IMAGE = "https://voyalyo.de/assets/travel-collage.jpg";

// Öffentlich indexierbare Seiten (index,follow) mit eigenem Title/Description/Canonical.
export const PUBLIC_SEO = {
  "/": {
    title: "Voyalyo – Reisen planen, Menschen treffen, gemeinsam erleben",
    description: "Voyalyo ist die Reiseplattform, um Reisen mit Lyo zu planen, passende Reiseideen zu entdecken und Reisende kennenzulernen, die zu deinem Stil passen.",
    canonical: "https://voyalyo.de/",
  },
  "/rechtliches": {
    title: "Rechtliches | Voyalyo",
    description: "Übersicht aller rechtlichen Informationen und Richtlinien von Voyalyo: Impressum, Datenschutz, Nutzungsbedingungen und mehr.",
    canonical: "https://voyalyo.de/rechtliches",
  },
  "/rechtliches/impressum": {
    title: "Impressum | Voyalyo",
    description: "Impressum und Anbieterkennzeichnung von Voyalyo gemäß § 5 DDG.",
    canonical: "https://voyalyo.de/rechtliches/impressum",
  },
  "/rechtliches/datenschutz": {
    title: "Datenschutz | Voyalyo",
    description: "Informationen zum Datenschutz bei Voyalyo: welche Daten verarbeitet werden, Rechtsgrundlagen und deine Rechte.",
    canonical: "https://voyalyo.de/rechtliches/datenschutz",
  },
  "/rechtliches/nutzungsbedingungen": {
    title: "Nutzungsbedingungen | Voyalyo",
    description: "Die Nutzungsbedingungen (AGB) für die Nutzung der Voyalyo-Reiseplattform.",
    canonical: "https://voyalyo.de/rechtliches/nutzungsbedingungen",
  },
  "/rechtliches/community-richtlinien": {
    title: "Community-Richtlinien | Voyalyo",
    description: "Die Community-Richtlinien von Voyalyo für einen respektvollen und sicheren Umgang miteinander.",
    canonical: "https://voyalyo.de/rechtliches/community-richtlinien",
  },
  "/rechtliches/sicherheitsrichtlinien": {
    title: "Sicherheitsrichtlinien | Voyalyo",
    description: "Sicherheitsrichtlinien und Hinweise für sicheres Reisen und Kennenlernen bei Voyalyo.",
    canonical: "https://voyalyo.de/rechtliches/sicherheitsrichtlinien",
  },
  "/rechtliches/premium-widerruf": {
    title: "Widerrufsbelehrung | Voyalyo",
    description: "Widerrufsbelehrung für Voyalyo-Premium-Abonnements.",
    canonical: "https://voyalyo.de/rechtliches/premium-widerruf",
  },
  "/rechtliches/konto-loeschen": {
    title: "Voyalyo-Konto löschen | Voyalyo",
    description: "So löschst du dein Voyalyo-Konto und welche Daten dabei entfernt werden.",
    canonical: "https://voyalyo.de/rechtliches/konto-loeschen",
  },
  "/rechtliches/support": {
    title: "Voyalyo Support – Hilfe & Kontakt",
    description: "Voyalyo Support: Hilfe, Kontaktmöglichkeiten und Antworten auf häufige Fragen.",
    canonical: "https://voyalyo.de/rechtliches/support",
  },
  "/hilfe-sicherheit": {
    title: "Hilfe & Sicherheit | Voyalyo",
    description: "Hilfe & Sicherheit bei Voyalyo: Tipps, Schutzfunktionen und Ansprechpartner rund um dein Konto.",
    canonical: "https://voyalyo.de/hilfe-sicherheit",
  },
  "/child-safety": {
    title: "Sicherheitsstandards zum Schutz von Kindern | Voyalyo",
    description: "Kinderschutz und Sicherheitsstandards bei Voyalyo (CSAE-Richtlinien) zum Schutz Minderjähriger.",
    canonical: "https://voyalyo.de/child-safety",
  },
};

// Kurz-Aliase → kanonische /rechtliches-URL (index,follow, aber Canonical zeigt auf die kanonische Variante).
export const ALIAS_TO_CANONICAL = {
  "/impressum": "/rechtliches/impressum",
  "/datenschutz": "/rechtliches/datenschutz",
  "/nutzungsbedingungen": "/rechtliches/nutzungsbedingungen",
  "/community-richtlinien": "/rechtliches/community-richtlinien",
  "/sicherheit": "/rechtliches/sicherheitsrichtlinien",
  "/premium-abo-widerruf": "/rechtliches/premium-widerruf",
  "/support": "/rechtliches/support",
  "/jugendschutz": "/child-safety",
};

// Liefert die SEO-Daten für einen Pfad. Unbekannte/private Pfade -> noindex.
export function resolveSeo(pathname) {
  const p = pathname.replace(/\/+$/, "") || "/";
  if (PUBLIC_SEO[p]) return { ...PUBLIC_SEO[p], indexable: true };
  if (PUBLIC_SEO[pathname]) return { ...PUBLIC_SEO[pathname], indexable: true };
  const alias = ALIAS_TO_CANONICAL[p];
  if (alias && PUBLIC_SEO[alias]) return { ...PUBLIC_SEO[alias], indexable: true };
  // Private/authentifizierungspflichtige oder unbekannte Seiten: nicht indexieren.
  return {
    title: "Voyalyo",
    description: "Voyalyo – Reisen planen, Menschen treffen, gemeinsam erleben.",
    canonical: null,
    indexable: false,
  };
}
